// extracted by mini-css-extract-plugin
export default {"forgotForm":"forgot-password_forgotForm__FtcAQ","forgotText":"forgot-password_forgotText__ht38X","messageText":"forgot-password_messageText__BpNAo"};